(() => {
  'use strict';

  const PRODUCT_MAIN = "main[data-template*='product']";
  let observerTimer;

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const cleanText = (value = '') =>
    String(value)
      .toLowerCase()
      .replace(/&amp;/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const optionNameFromFieldset = (fieldset) => {
    const legend = fieldset.querySelector(':scope > legend');
    if (!legend) return '';

    const textNode = Array.from(legend.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
    return textNode?.textContent?.trim() || legend.textContent?.trim() || '';
  };

  const updateFieldset = (fieldset, animate = false) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    const legend = fieldset.querySelector(':scope > legend');
    if (!checked || !legend) return;

    let selected = legend.querySelector('.vow-selected-option');
    if (!selected) {
      selected = document.createElement('span');
      selected.className = 'vow-selected-option';
      selected.setAttribute('aria-live', 'polite');
      legend.appendChild(selected);
    }
    selected.textContent = `Selected: ${checked.value}`;

    fieldset.querySelectorAll('label.variant-option__button-label').forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      const active = input === checked;
      label.dataset.vowSelected = active ? 'true' : 'false';
      if (!active) label.removeAttribute('data-vow-animate');
    });

    if (animate) {
      const activeLabel = checked.closest('label.variant-option__button-label');
      if (activeLabel) {
        activeLabel.dataset.vowSelected = 'false';
        requestAnimationFrame(() => {
          activeLabel.dataset.vowSelected = 'true';
        });
      }
    }
  };

  const enhancePicker = (root = document, animate = false) => {
    root.querySelectorAll(`${PRODUCT_MAIN} variant-picker fieldset.variant-option--buttons`).forEach((fieldset) => {
      updateFieldset(fieldset, animate);
    });
  };

  const mediaScore = (slide, requestedColor) => {
    const image = slide.querySelector('img');
    const alt = cleanText(image?.getAttribute('alt') || '');
    const src = cleanText(image?.currentSrc || image?.getAttribute('src') || '');
    const haystack = `${alt} ${src}`;
    const color = cleanText(requestedColor);

    if (!color || !haystack.includes(color)) return -1;

    let score = 10;
    if (alt.includes(color)) score += 5;
    if (haystack.includes('graphic')) score += 4;
    if (haystack.includes('front and back')) score += 3;
    if (haystack.includes('front view')) score += 3;
    if (haystack.includes('back view')) score += 2;
    if (haystack.includes('alternate')) score -= 1;
    return score;
  };

  const selectMatchingColorMedia = (requestedColor) => {
    const moveGallery = () => {
      const main = document.querySelector(PRODUCT_MAIN);
      const slideshow = main?.querySelector('media-gallery slideshow-component');
      if (!slideshow) return;

      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      if (!slides.length) return;

      let targetIndex = -1;
      let bestScore = -1;
      slides.forEach((slide, index) => {
        const score = mediaScore(slide, requestedColor);
        if (score > bestScore) {
          bestScore = score;
          targetIndex = index;
        }
      });

      if (targetIndex < 0) return;

      if (typeof slideshow.select === 'function') {
        slideshow.select(targetIndex, undefined, { animate: false });
      } else {
        slides[targetIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    moveGallery();
    window.setTimeout(moveGallery, 180);
    window.setTimeout(moveGallery, 650);
  };

  const isColorInput = (input) => {
    const fieldset = input.closest('fieldset');
    const optionName = optionNameFromFieldset(fieldset || document.createElement('fieldset'));
    return /color|colour/i.test(optionName) || /^color-/i.test(input.name || '');
  };

  const checkedColorInput = (picker) => {
    const checkedInputs = Array.from(picker.querySelectorAll('input[type="radio"]:checked'));
    return checkedInputs.find((input) => isColorInput(input));
  };

  onReady(() => {
    const main = document.querySelector(PRODUCT_MAIN);
    if (!main) return;

    enhancePicker(document);

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.type !== 'radio' || !input.closest(`${PRODUCT_MAIN} variant-picker`)) return;

      const fieldset = input.closest('fieldset.variant-option--buttons');
      if (fieldset) updateFieldset(fieldset, true);

      if (isColorInput(input)) {
        selectMatchingColorMedia(input.value);
      }

      window.setTimeout(() => enhancePicker(document), 220);
      window.setTimeout(() => enhancePicker(document), 700);
    });

    document.addEventListener('pointerover', (event) => {
      if (!(event.target instanceof Element)) return;
      const label = event.target.closest(`${PRODUCT_MAIN} variant-picker label.variant-option__button-label`);
      if (!label) return;
      if (event.relatedTarget instanceof Node && label.contains(event.relatedTarget)) return;

      const input = label.querySelector('input[type="radio"]');
      if (!(input instanceof HTMLInputElement) || !isColorInput(input) || input.disabled || input.getAttribute('aria-disabled') === 'true') return;

      selectMatchingColorMedia(input.value);
    });

    document.addEventListener('pointerout', (event) => {
      if (!(event.target instanceof Element)) return;
      const label = event.target.closest(`${PRODUCT_MAIN} variant-picker label.variant-option__button-label`);
      if (!label) return;
      if (event.relatedTarget instanceof Node && label.contains(event.relatedTarget)) return;

      const picker = label.closest('variant-picker');
      if (!picker) return;
      const checked = checkedColorInput(picker);
      if (checked) selectMatchingColorMedia(checked.value);
    });

    const observer = new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => enhancePicker(document), 40);
    });
    observer.observe(main, { childList: true, subtree: true });
  });
})();
